import { useEffect, useState } from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Iconify from 'src/components/iconify';
import PropTypes from 'prop-types';
import Image from 'src/components/image';

const VisuallyHiddenInput = styled('input')({
  // clip: 'rect(0 0 0 0)',
  // clipPath: 'inset(50%)',
  height: '100%',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '100%',
  opacity: 0,
  cursor: 'pointer',
});

export default function UploadProfile({
  orgProfileImageUrl,
  isEditMode,
  imageFile,
  setImageFile,
}) {
  // states

  // functions
  const onChangeImageHandler = e => {
    const _currentFile = e.target.files[0];

    const _file = Object.assign(_currentFile, {
      preview: URL.createObjectURL(_currentFile),
    });

    setImageFile(_file);
  };

  return (
    <Box
      sx={{
        bgcolor: theme => theme.palette.background.primaryGrey2,
        color: theme => theme.palette.content.primaryBlack3,
        height: '80px',
        display: 'flex',
        width: '80px',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '9px',
        position: 'relative',
        cursor: 'default',
      }}
    >
      {imageFile && <Image src={imageFile.preview} alt="Org Image URL" />}
      {orgProfileImageUrl && !imageFile && (
        <Image src={orgProfileImageUrl} alt="Org Image URL" />
      )}
      {!imageFile && !orgProfileImageUrl && (
        <Stack spacing="4px" alignItems="center">
          <Iconify icon="tabler:photo" width={28} />
        </Stack>
      )}
      {isEditMode.value && (
        <IconButton
          sx={{
            position: 'absolute',
            bottom: '0px',
            right: '-16px',
            padding: '6px',
            cursor: 'pointer',
          }}
          variant="contained"
        >
          <VisuallyHiddenInput
            type="file"
            accept="image/*"
            title=""
            onChange={onChangeImageHandler}
          />
          <Iconify icon="tabler:pencil" width={16} />
        </IconButton>
      )}
    </Box>
  );
}

UploadProfile.propTypes = {
  orgProfileImageUrl: PropTypes.string.isRequired,
  isEditMode: PropTypes.object.isRequired,
  imageFile: PropTypes.object,
  setImageFile: PropTypes.func.isRequired,
};
